import React from "react";

import Label from "@busbud/design-system-components/dist/Label";
import Link from "@busbud/design-system-components/dist/Link/Link";

import { useAppContext } from "@app/helpers/hooks";

interface Props {
  goToSignIn: (email?: string) => void;
}

export const SignUpFooter = ({ goToSignIn }: Props) => {
  const { translator } = useAppContext();

  return (
    <Label size="lg" fontWeight="bold" align="center">
      {`${translator.t("!account.sign-up.already-signed-up")} `}
      <Link
        size="lg"
        align="center"
        fontWeight="bold"
        onClick={() => goToSignIn()}
      >
        {translator.t("!account.sign-up.sign-in-link")}
      </Link>
    </Label>
  );
};
